/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from "axios";
import { getToken } from "@/util/auth";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style

axios.defaults.timeout = 10000;
//返回其他状态码
axios.defaults.validateStatus = function(status) {
  return status >= 200 && status <= 500; // 默认的
};
//跨域请求，允许保存cookie
axios.defaults.withCredentials = false;
// NProgress Configuration
NProgress.configure({
  showSpinner: false
});

//HTTPrequest拦截
axios.interceptors.request.use(
  config => {



    NProgress.start(); // start progress bar
    const meta = config.meta || {};
    const isToken = meta.isToken === false;
    // config.headers['Authorization'] = `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`;
    if (getToken() && !isToken) {
      config.headers["X-Litemall-Token"] = getToken(); // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    }

    //headers中配置serialize为true开启序列化
    // if (config.method === "post" && meta.isSerialize === true) {
    //   config.data = serialize(config.data);
    // }

    //------------------------------------------------------------------------------------------------------------------
    let userDataStr = localStorage.getItem("userData");
    if(userDataStr == null || userDataStr== undefined || userDataStr.length == 0 ||userDataStr == 'null'){
      //console.log("userData  = null");
    }
    else {
      //console.log("userDataStr = ",userDataStr);
      let objUser =  JSON.parse(userDataStr);
      let token = objUser.token;
      config.headers["token"] = token;
    }

    //console.log("config = ",config);

    NProgress.done();
    return config;
  },
  error => {
    NProgress.done();
    return Promise.reject(error);
  }
);

//HTTPresponse拦截
axios.interceptors.response.use(
  res => {
    if (res.status == 200) {
      NProgress.done();
    }
    return res;
  },
  error => {
    NProgress.done();
    return Promise.reject(new Error(error));
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/util/axios.js